(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-contact-reveal]').forEach(root => root.classList.add('is-visible'));

    scope.querySelectorAll('[data-contact-form]').forEach(form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      form.querySelectorAll('input[required],textarea[required]').forEach(field => {
        const error = field.parentElement.querySelector('[data-field-error]');
        field.addEventListener('invalid', () => { field.setAttribute('aria-invalid', 'true'); if (error) error.hidden = false; });
        field.addEventListener('input', () => { if (!field.validity.valid) return; field.removeAttribute('aria-invalid'); if (error) error.hidden = true; });
      });
      form.addEventListener('submit', event => {
        if (!form.checkValidity()) return;
        const button = form.querySelector('[data-contact-submit]');
        button?.setAttribute('aria-busy', 'true');
        if (button) button.disabled = true;
      });
      form.querySelector('[data-contact-success],[data-contact-errors]')?.focus();
    });
  };

  const pauseMarquees = () => document.querySelectorAll('[data-contact-marquee]').forEach(marquee => marquee.classList.toggle('is-paused', document.hidden));
  initialize();
  document.addEventListener('visibilitychange', pauseMarquees);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
